import React from "react";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../../../misc/windowDimensions";
import CardArticles from "./CardArticles";

export default function Articles({article, event}) {
// event/all
  const { height, width } = useWindowDimensions()

  return (
    <div
      style={{
        // height: "70px",
        padding: "0px 0px",
        backgroundColor: "#F9F9FA",
      }}
    >
      <div className="container">
        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "60px",
            paddingBottom: "20px",
          }}
        >
          <p style={{ margin: 0, fontWeight: 700 }} className="h6-nunito">
            Event Terbaru PSrE
          </p>
          <div>
            <Link
              // onClick={() => history.push('event/all')}
              style={{
                backgroundColor: "#1672BD",
                color: "white",
                border: "1px solid #1672BD",
              }}
              className="nav-link btn p-nunito btn-instance"
              to="/event/all"
            >
              Baca Semua
            </Link>
          </div>
        </div>
        <div
          style={{ flexDirection: "row", display: "flex", paddingBottom: 70 }}
        >
          {event.filter((item,idx) => {
            return width < 700 ? idx < 1 : width < 1024 ? idx < 2 : idx < 3}).map((data) => (
            <div style={{flex: 1, padding: '0px 10px'}}>
              <CardArticles data={data} isEvent/>
            </div>
          ))}
        </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "30px",
            paddingBottom: "40px",
          }}
        >
          <p style={{ margin: 0, fontWeight: 700 }} className="h6-nunito">
            Berita Terbaru
          </p>
          <div>
            <Link
              // onClick={() => console.log("PENCET1")}
              style={{
                backgroundColor: "#1672BD",
                color: "white",
                border: "1px solid #1672BD",
              }}
              className="nav-link btn p-nunito btn-instance"
              to="/event/blog"
            >
              Baca Semua
            </Link>
          </div>
        </div>
        <div
          style={{ flexDirection: "row", display: "flex", paddingBottom: 70 }}
        >
          {article.filter((item,idx) => {
            return width < 700 ? idx < 1 : width < 1024 ? idx < 2 : idx < 3}).map((data) => (
            <div style={{flex: 1, padding: '0px 10px'}}>
              <CardArticles data={data} isEvent/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
